import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ConsentPopupComponent } from './shared/components/consent-popup/consent-popup.component';
import { SharedService } from './services/shared/shared.service';
import { ResultsService } from './services/results/results.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'TrialResultsWeb';
  encodedSearchHeader: string = btoa('SearchQuery');
  encodedPrivacyHeader: string = btoa('privacyPolicy');
  encodedTokenHeader: string = btoa('token');

  constructor(
    private modalService: NgbModal,
    private sharedService: SharedService,
    private resultService: ResultsService,
    private route: ActivatedRoute
  ) {
    this.sharedService.isUSALocation.subscribe((result) => {
      console.log(result);
      let privacyPolicy = localStorage.getItem(this.encodedPrivacyHeader);

      if (result === false && !privacyPolicy) {
        const modalRef = this.modalService.open(ConsentPopupComponent, {
          centered: false,
          size: 'sm',
          backdrop: false,
          windowClass: 'consent-popup',
          keyboard: true,
        });

        modalRef.componentInstance.passEntry.subscribe((receivedEntry: any) => {
          if (receivedEntry) {
            this.resultService.getGeoLocation().then((success) => {});
          }
          this.sharedService.setPrivacyPolicy(receivedEntry);
        });
      } else if (result === true || privacyPolicy) {
        this.resultService.getGeoLocation().then((success) => {});
      }
    });
  }

  ngOnInit() {
    this.sharedService.checkUSALocation();
    let data = {
      ResultLocationList: [],
      ResultCollaboratorList: [],
      Keywords: '',
    };
    sessionStorage.setItem(
      this.encodedSearchHeader,
      btoa(JSON.stringify(data))
    );
    this.route.queryParams.subscribe((params) => {
      const encodedValue = params['enc'];
      if (encodedValue) {
        sessionStorage.setItem(this.encodedTokenHeader, encodedValue);
      }
    });
  }
}
